import { render, staticRenderFns } from "./ResearchSectionFilters.vue?vue&type=template&id=6096fe8e"
import script from "./ResearchSectionFilters.vue?vue&type=script&lang=js"
export * from "./ResearchSectionFilters.vue?vue&type=script&lang=js"
import style0 from "./ResearchSectionFilters.vue?vue&type=style&index=0&id=6096fe8e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6096fe8e')) {
      api.createRecord('6096fe8e', component.options)
    } else {
      api.reload('6096fe8e', component.options)
    }
    module.hot.accept("./ResearchSectionFilters.vue?vue&type=template&id=6096fe8e", function () {
      api.rerender('6096fe8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSectionFilters.vue"
export default component.exports